import React, { useState } from "react";

const TeamCard = ({ name, designation, img, page, department, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="block cursor-pointer focus:outline-none focus:ring-2 focus:ring-red-500 rounded-md"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div
        className={`relative w-60 text-center mx-auto rounded ${page !== "team" ? "bg-borderRed" : ""}`}
        style={{ height: "75px" }}
      >
        {/* Outer Border */}
        <div className="border-red-500 rounded-md p-4 flex items-center justify-center h-full">
          {/* Name */}
          <h2 className={`font-bold ${page !== "team" ? "text-white" : "text-black text-2xl"}`}>
            {name}
          </h2>
        </div>
      </div>
    </div>
  );
};

const TeamMemberModal = ({ member, onClose }) => {
  if (!member) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-60 backdrop-blur-sm animate-modalFadeIn"
      onClick={onClose}
    >
      {/* Modal Container */}
      <div 
        className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100 max-h-[90vh] flex flex-col animate-modalScaleUp"
        onClick={(e) => e.stopPropagation()}
      >
        <style>{`
          @keyframes modalFadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes modalScaleUp {
            from { transform: scale(0.95); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
          }
          .animate-modalFadeIn {
            animation: modalFadeIn 0.2s ease-out forwards;
          }
          .animate-modalScaleUp {
            animation: modalScaleUp 0.25s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          }
        `}</style>

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 p-2 text-gray-400 hover:text-gray-700 bg-gray-50 hover:bg-gray-100 rounded-full transition-all duration-200"
          aria-label="Close modal"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Scrollable Content */}
        <div className="overflow-y-auto p-6 md:p-8">
          <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
            {/* Image / Avatar Fallback */}
            <div className="w-32 h-32 md:w-36 md:h-36 rounded-xl overflow-hidden bg-gray-50 flex-shrink-0 border border-gray-100 shadow-inner flex items-center justify-center">
              {member.img ? (
                <img
                  src={member.img}
                  alt={member.name}
                  className={`w-full h-full transition-transform duration-300 hover:scale-105 ${
                    member.imgFit === "contain" ? "object-contain p-1.5" : "object-cover object-top"
                  }`}
                />
              ) : (
                <div className="w-full h-full bg-[#fef2f2] flex flex-col items-center justify-center text-[#ef5b5b]">
                  <svg className="w-16 h-16 opacity-80" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  </svg>
                </div>
              )}
            </div>

            {/* Profile Header */}
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 leading-tight">
                {member.name}
              </h3>
              <p className="text-[#ef5b5b] font-bold text-sm md:text-base mt-2 uppercase tracking-wider">
                {member.designation}
              </p>
              {member.department && (
                <span className="inline-block bg-gray-100 text-gray-600 text-xs font-semibold px-2.5 py-1 rounded-full mt-2">
                  {member.department}
                </span>
              )}
            </div>
          </div>

          {/* Biography Text */}
          <div className="mt-6 border-t border-gray-100 pt-5">
            <h4 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-2.5">
              Biography
            </h4>
            <div className="text-gray-700 text-sm md:text-base leading-relaxed whitespace-pre-line font-medium">
              {member.bio || "Biography details will be available soon."}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const teamMembers = [
  {
    id: 1,
    name: "Vikash Jha",
    designation: "Founder",
    img: "https://ik.imagekit.io/bhavishya/web-final/Screenshot%202025-02-08%20at%207.02.45%20PM.png?updatedAt=1739021661964",
    bio: "Vikash is a software engineer with over a decade of experience in the technology industry. Alongside his professional career, he founded Bhavishya Ngo over ten years ago with a vision to create meaningful and lasting change in the lives of underserved communities.\n\nDriven by the belief that opportunity should be accessible to everyone, he leads initiatives focused on quality education, skill development, sustainable livelihoods, environmental conservation, and community health. Through Bhavishya , he works to empower children, women, and marginalized families by enabling them to build brighter, more self-reliant futures.\n\nHe believes that technology, innovation, and community-driven action can together create a more inclusive and equitable society.profession, he built the organisation from that initial effort into its current work across education, elder care, livelihood, and environment initiatives."
  },
  {
    id: 2,
    name: "Rahul Pandey",
    designation: "Co-Founder and Social Development Professional",
    img: "https://ik.imagekit.io/bhavishya/web-final/Team%20Members/Rahul%20Pandey.jpeg",
    bio: "Rahul Pandey is a passionate social development professional committed to serving communities and creating meaningful social impact. His journey began with a Bachelor's degree in Mechanical Engineering, but his desire to work directly with people and contribute to social change led him to pursue a Master's degree in Social Work.\n\nOver the course of his career, Rahul has gained extensive experience working with the Government of India, where he served for five years under the Ministry of Youth Affairs & Sports and the Ministry of Jal Shakti. As a District Project Officer for the Namami Gange Programme, he worked closely with local communities, government agencies, and stakeholders to promote environmental conservation, public awareness, and sustainable development initiatives.\n\nDriven by a strong commitment to public service, Rahul later moved to Ireland and currently works with the Health Service Executive (HSE) in Dublin, supporting healthcare services and community well-being. His diverse professional experience across social development, environmental sustainability, public administration, and healthcare has strengthened his belief in the power of compassion, collaboration, and community engagement.\n\nRahul is dedicated to empowering individuals, supporting vulnerable communities, and contributing to initiatives that create lasting positive change. He brings enthusiasm, leadership, and a people-centered approach to every role he undertakes."
  },
  {
    id: 3,
    name: "Nitish Bansal",
    designation: "CSR & Technology Advisor",
    img: "https://ik.imagekit.io/bhavishya/web-final/Team%20Members/Nitish%20Bansal.jpeg",
    bio: "A seasoned Pre-Sales IT professional with over a decade of experience across Information Technology and Corporate Social Responsibility. Nitish is focused on leveraging technology to drive social impact, with a particular commitment to empowering underprivileged children and marginalised communities through sustainable initiatives."
  },
  {
    id: 4,
    name: "Om Narayan Singh",
    designation: "Chief Digitalisation Officer",
    img: "https://ik.imagekit.io/bhavishya/web-final/Team%20Members/omnarayansingh.jpeg",
    bio: "Om is the Chief Digitalisation Officer at Bhavishya, where he leads the organisation’s technology and digital transformation efforts. He is the founder of EdFoal AI and has built AI-powered automation systems for businesses across the UK and US, spanning insurance operations, healthcare and real estate. He brings that same product-first thinking to social impact."
  },
  {
    id: 5,
    name: "Vedhika Yadav",
    designation: "Senior Project Manager",
    img: "https://ik.imagekit.io/bhavishya/web-final/Team%20Members/VEDHIKA%20YADAV.jpeg?updatedAt=1784051889775",
    bio: "Vedhika Yadav leads a team of 10 across multiple concurrent education and vocational training programmes as Senior Project Manager at Bhavishya NGO serving as the primary point of contact for funding partners including M3M Foundation and other CSR partners.\n\nAlong with other projects, she also oversees the MRC/Gyan Rath programme and Project Udaan, delivered in collaboration with Saakshar Hum Foundation, managing each end-to-end — from proposal development and funder relationship to field implementation and reporting. She has contributed to designing monitoring and evaluation frameworks, defining indicators, developing data collection tools, and establishing reporting mechanisms aligned with donor requirements, and prepares the survey reports and donor updates that keep partners informed of progress.\n\nWith 7 years of experience in diverse fields Vedhika combines a research-methodology background from her M.Sc. in Biomedical Sciences with training in counselling psychology from her M.A. — a pairing that supports both her work designing monitoring and evaluation frameworks and her engagement with the students and field staff those programmes serve.\n\nHer experience managing multiple concurrent, differently-funded programmes at the same time has also given her direct, hands-on experience with donor accountability — managing separate budgets, reporting cadences, and funder expectations in parallel."
  },
  {
    id: 6,
    name: "Harpreet Aswal",
    designation: "Youth Mentor & Sports Coach",
    img: "https://ik.imagekit.io/bhavishya/web-final/Team%20Members/Harpreet%20Aswal.jpeg",
    bio: "Harpreet Aswal is a graduate with extensive experience training and developing young basketball players, combined with management expertise from leadership roles in retail and education. His ability to mentor, motivate, and build meaningful relationships with children makes him a valued contributor to community development, promoting discipline, teamwork, and holistic growth through sports and education."
  },
  {
    id: 7,
    name: "Abhinav Tomar",
    designation: "Legal Scholar",
    img: "https://ik.imagekit.io/bhavishya/web-final/Team%20Members/Abhinav%20Tomar.jpeg",
    bio: "Dr. Abhinav Tomar is a legal scholar and former practicing attorney, currently Assistant Professor of Law at Christ University, Delhi NCR Campus. He completed his B.A. LL.B. (Hons.) from RMLNLU Lucknow, an LL.M. in Banking and Finance from NLU Jodhpur, and his Ph.D. from IFTM University, and formerly practiced before the Supreme Court of India and the Delhi High Court."
  },
  {
    id: 8,
    name: "Harshit Kumar",
    designation: "Researcher Scholar",
    img: "https://ik.imagekit.io/bhavishya/web-final/Team%20Members/Harshit%20Kumar.jpeg",
    bio: "Harshit Kumar holds a Bachelor's degree from the University of Delhi, a Master's in Hindi Literature from Jamia Millia Islamia, and an M.Phil. from JNU, and is currently pursuing a Ph.D. in Hindi at the University of Delhi. He brings experience across journalism, literature, CSR, and development projects, working across media organisations, academic institutions, and civil society initiatives through writing, research, and communication strategy."
  },
  {
    id: 9,
    name: "Archana",
    designation: "'Srijan' Initiative Lead",
    img: "https://ik.imagekit.io/bhavishya/web-final/Team%20Members/Archana%20.jpeg",
    bio: "Archana leads our livelihood Initiative ‘Srijan‘ with resilience and determination. After losing her husband, she rebuilt her career by developing soft skills, learning stitching, and completing vocational courses in marketing. She now leads a team of 15 women from underprivileged backgrounds, inspiring them through dedication and leadership by example."
  },
  {
    id: 10,
    name: "Shalu Jha",
    designation: "National Program Coordinator",
    img: "https://ik.imagekit.io/bhavishya/web-final/Team%20Members/Shalu%20Jha.jpeg",
    bio: "Shalu Jha is the National Program Coordinator at Bhavishya Trust with 5 years of experience in education, program coordination, and community development. She holds a Bachelor's degree, is currently pursuing an MBA, and holds professional certifications in IT Help Desk, Administrative Assistance, and Microsoft Azure. She is focused on empowering underprivileged children through quality education and sustainable social impact."
  },
  {
    id: 11,
    name: "Pallav Biswas",
    designation: "West Bengal Coordinator",
    img: "https://ik.imagekit.io/bhavishya/web-final/Team%20Members/Pallav%20Biswas.jpeg",
    bio: "A social worker from West Bengal, Pallav Vishwas received the NSS National Award from the President of India at Rashtrapati Bhavan in 2022. He leads social service initiatives across districts in West Bengal, working with a network of 10,000 youth."
  },
  {
    id: 12,
    name: "Lakshmi Shetty",
    designation: "Bengaluru Coordinator",
    img: "https://ik.imagekit.io/bhavishya/web-final/Team%20Members/Lakshmi%20Shetty.jpeg",
    bio: "Lakshmi Shetty, an MSc Economics student, serves as Bhavishya NGO's Coordinator for Bangalore, managing day-to-day operations and outreach across the city — including stationery drives, sanitary napkin distribution, food drives, and free education initiatives for children in slum communities."
  },
  {
    id: 13,
    name: "Kalpana Jhajharia",
    designation: "Business Owner & Social Welfare Advocate",
    img: "https://ik.imagekit.io/bhavishya/web-final/Team%20Members/Kalpana%20Jhajharia.jpeg",
    imgFit: "contain",
    bio: "Kalpana Jhajharia holds an M.A., B.Ed, LL.B, and a Handicraft Teacher Course qualification. A business owner based in Noida (originally from Jhunjhunu, Rajasthan), she actively conducts, hosts, and participates in social welfare activities to spread awareness and motivate community engagement."
  },
  {
    id: 14,
    name: "Aditya Narayan Dubey",
    designation: "Project Associate",
    img: "https://ik.imagekit.io/bhavishya/web-final/Team%20Members/Aditya%20Narayan%20Dubey.jpeg",
    bio: "Aditya Narayan Dubey is pursuing a Bachelor of Computer Applications (BCA) and serves as a Project Associate at Bhavishya NGO, organising events and coordinating programmes. In 2025, he also gained experience as an IT Help Desk Associate, developing strong problem-solving and communication skills."
  }
];

const MeetOurTeam = ({ heading, isFirstRow, page }) => {
  const [activeMember, setActiveMember] = useState(null);
  const firstRow = teamMembers.slice(0, 4);
  const otherRows = teamMembers.slice(4);

  return (
    <div className="bg-cream py-10">
      {heading && <h1 className="text-center text-4xl font-bold mb-10">{heading}</h1>}
      <div className="space-y-10 max-w-7xl mx-auto px-4">
        {isFirstRow && (
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 justify-center">
            {firstRow.map((member) => (
              <TeamCard
                key={member.id}
                name={member.name}
                designation={member.designation}
                img={member.img}
                department={member.department}
                page={page}
                onClick={() => setActiveMember(member)}
              />
            ))}
          </div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 justify-center">
          {otherRows.map((member) => (
            <TeamCard
              key={member.id}
              name={member.name}
              designation={member.designation}
              img={member.img}
              department={member.department}
              page={page}
              onClick={() => setActiveMember(member)}
            />
          ))}
        </div>
      </div>

      {activeMember && (
        <TeamMemberModal member={activeMember} onClose={() => setActiveMember(null)} />
      )}
    </div>
  );
};

export default MeetOurTeam;
